import { useOverviewContext } from "../context/OverviewContext";
import Header from "../Layout/Header";
import Sidebar from "../Layout/Sidebar";
import config from '../config';
import '../assets/css/contact.css';
import { FooterMobile } from "../Layout/FooterMobile";
import imageFAQ from '../assets/images/siteImg/checklistImg/Image_FAQ.png';
import bannerContactImage from '../assets/images/siteImg/contact/Banner_Contact_Desktop.png';
import chatImage from '../assets/images/siteImg/contact/Image_Chat.png';
import answersImage from '../assets/images/siteImg/contact/Image_Answers.png';
import Image_LCCommunity from '../assets/images/siteImg/contact/Image_LCCommunity.png';
import customerSupportIconImage from '../assets/images/siteImg/contact/Icon_CustomerSupport.svg?url';
import IMAGES from '../config/imageConfig';
import ButtonLink from "../components/ButtonLink";
import { getActiveToolIDs, getChatUrl, shouldShowK12Zone, shouldShowLearningCoachCommunity } from "../utils/menuUtils";
import { useToolSettings } from "../context/ToolSettingsContext";

export function Contact() {
const { HOME, COMMUNITY } = config.app.routes;
const {userRoleVal, identityId} = useOverviewContext();
console.log(IMAGES);
const chatUrl = identityId ? getChatUrl(identityId) : '';
// Get tool settings from context
const { toolSettings } = useToolSettings();
const activeToolIDs = getActiveToolIDs(toolSettings);
const showLearningCoachCommunity = shouldShowLearningCoachCommunity(userRoleVal, activeToolIDs);
console.log(showLearningCoachCommunity);

return (
<>

<div className="home-layout">
    <div className="sidebar-wrapper">
    <Sidebar />
    </div>
    <div className="body-wrapper-content">
        <div className="row">
            <div className="col-12">
                <Header />
                <main id="main" role="main">
                    <div className="main-content" id="contact-page">
                        <div className="row">
                            <div className="col-12">
                                <nav aria-label="breadcrumb" className="d-none d-sm-block">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <a href={HOME}>Home</a>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <span>Contact</span>
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>

                        <div className="wp-block-k12-section container-fluid rounded-top-corners bg-color-light-gray-2 common-banner-bg-white">
                            <div className="row">
                                <div className="col-12 g-0">
                                    <div className="wp-block-k12-hero">
                                        <div className="row no-wrap">
                                            <div className="col-sm-12 col-md-6 col-xl-6 col-xxl-8 align-self-center">
                                                <h1 className="">Contact</h1>
                                                <p className="heading-4">Need support? Find the answers you need.</p>
                                            </div>
                                            <div className="col-sm-12 col-md-6 col-xl-6 col-xxl-4 justify-content-center d-flex">
                                                <img src={bannerContactImage}
                                                    alt="" className="img-fluid"/>
                                                <div className="circle-background"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="wp-block-k12-section container-fluid  bg-transparent">
                            <div className="row">
                                <div className="col-12 g-0">
                                    <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-1 wp-block-columns-is-layout-flex">
                                        <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow flex-1">
                                            <h2 className="wp-block-heading">We’ll help fill in the blanks with the answers you need! Reach out in whatever way is best for you.</h2>
                                        </div>
                                        <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow flex-2"></div>
                                    </div>
                                    <div style={{ height: "16px" }} aria-hidden="true" className="wp-block-spacer"></div>



                                    <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-6 wp-block-columns-is-layout-flex">
                                        <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow flex-1">
                                            <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-2 wp-block-columns-is-layout-flex">
                                                <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow"
                                                    style={{ flexBasis: "220px" }} >
                                                    <figure className="wp-block-image size-full">
                                                        <img src={chatImage}
                                                            alt="" className="wp-image"/></figure>
                                                </div>



                                                <div
                                                    className="wp-block-column align-items-start d-flex flex-column justify-content-center is-layout-flow wp-block-column-is-layout-flow">
                                                    <h3 className="wp-block-heading"><strong>Need to chat?</strong></h3>



                                                    <p>Talk to a live customer support representative. </p>



                                                    <div className="wp-block-buttons is-layout-flex wp-block-buttons-is-layout-flex">
                                                        <div className="wp-block-button btn-primary"><a
                                                            className="wp-block-button__link wp-element-button"
                                                            href={chatUrl}
                                                            target="_blank" rel="noreferrer noopener">Chat Now</a></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div style={{ height: "1px" }} aria-hidden="true" className="wp-block-spacer my-5 bg-color-light-gray-1"></div>


                                            <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-3 wp-block-columns-is-layout-flex">
                                                <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ flexBasis: "220px" }}>
                                                    <figure className="wp-block-image size-full">
                                                        <img decoding="async" width="440" height="380"
                                                            src={imageFAQ}
                                                            alt="" className="wp-image-463"
                                                        /></figure>
                                                </div>



                                                <div
                                                    className="wp-block-column align-items-start d-flex flex-column justify-content-center is-layout-flow wp-block-column-is-layout-flow">
                                                    <h3 className="wp-block-heading"><strong><strong>School FAQs</strong></strong></h3>



                                                    <p>Have some basic questions? Start here for quick answers.</p>



                                                    <div className="wp-block-buttons is-layout-flex wp-block-buttons-is-layout-flex">
                                                        <div className="wp-block-button btn-primary"><a
                                                            className="wp-block-button__link wp-element-button"
                                                            href="/k12-checklist/school-start-faqs/">View
                                                            FAQs</a></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div style={{ height: "1px" }} aria-hidden="true" className="wp-block-spacer my-5 bg-color-light-gray-1"></div>

                                            <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-4 wp-block-columns-is-layout-flex">
                                                <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow"  style={{ flexBasis: "220px" }} >
                                                    <figure className="wp-block-image size-full"><img loading="lazy" decoding="async"
                                                        width="440" height="380"
                                                        src={answersImage}
                                                        alt="" className="wp-image-461"
                                                    /></figure>
                                                </div>



                                                <div
                                                    className="wp-block-column align-items-start d-flex flex-column justify-content-center is-layout-flow wp-block-column-is-layout-flow">
                                                    <h3 className="wp-block-heading"><strong><strong>Need to dig a little
                                                        deeper?</strong></strong></h3>

                                                    <p>Check the many resources at <strong>Help.K12.com</strong>.</p>

                                                    <div className="wp-block-buttons is-layout-flex wp-block-buttons-is-layout-flex">
                                                        <div className="wp-block-button btn-primary"><a
                                                            className="wp-block-button__link wp-element-button" href="http://help.K12.com"
                                                            target="_blank" rel="noreferrer noopener">Visit Help Site</a></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div style={{ height: "1px" }} aria-hidden="true" className="wp-block-spacer my-5 bg-color-light-gray-1"></div>

                                            {userRoleVal?.toUpperCase() !== "STUDENT" && showLearningCoachCommunity && ( 
                                                <div id="LC-community" className="wp-block-columns lc-community-block is-layout-flex wp-container-core-columns-is-layout-5 wp-block-columns-is-layout-flex">
                                                    <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ flexBasis: "220px" }}>
                                                        <figure className="wp-block-image size-full"><img loading="lazy" decoding="async"
                                                            width="440" height="380"
                                                            src={Image_LCCommunity}
                                                            alt="" className="wp-image-923" />
                                                        </figure>
                                                    </div>



                                                    <div
                                                        className="wp-block-column align-items-start d-flex flex-column justify-content-center is-layout-flow wp-block-column-is-layout-flow">
                                                        <h3 className="wp-block-heading"><strong><strong>Ask Your LC Community</strong></strong>
                                                        </h3>



                                                        <p>Be sure to connect with your local and national Learning Coach Communities for quick
                                                            tips and advice in a secure, welcoming environment.</p>



                                                        <div className="wp-block-buttons is-layout-flex wp-block-buttons-is-layout-flex">
                                                            <div className="wp-block-button btn-primary lc-btn">
                                                                {/* <a
                                                                className="wp-block-button__link wp-element-button"
                                                                href="https://community.k12.com/" target="_blank"
                                                                rel="noreferrer noopener">Join the LC Community</a> */}
                                                                
                                                                <ButtonLink
                                                                urlKey="COMMUNITY_URL"
                                                                label="Join the LC Community"
                                                                className="wp-block-button__link wp-element-button"
                                                                source="links"
                                                                target="_blank"
                                                                />

                                                                </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                        </div>

                                        <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow flex-2">
                                            <p></p>



                                            <div className="wp-block-k12-section container-fluid  bg-color-blue-t1-checklist p-5">
                                                <div className="row">
                                                    <div className="col-12 g-0">
                                                        <figure className="wp-block-image size-large">
                                                            <img src={customerSupportIconImage}
                                                            className="wp-image-460" />
                                                        </figure>



                                                        <h3 className="wp-block-heading">Customer Support</h3>



                                                        <p>Use the phone number below to contact a customer support representative.</p>



                                                        <p>866-910-9528</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>

    </div>
    <FooterMobile />
</div>

</>
);
}